import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query PersonPage($id: ID!,  $masterLimit: Int) {
        PersonPage: Person(id: $id) {
        ...personBigAwards
        ...personDetail
        ...personBigDetail
        ...personArtworks
        ...personFilms
        ...personCompanies
      }
    }
    ${fragments.relationshipTypeDetail}
    ${fragments.filmRelationships}
    ${fragments.companyDepartmentDetail}
    ${fragments.personFilms}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.profession}
    ${fragments.locationTree}
    ${fragments.location}
    ${fragments.companyArtworks}
    ${fragments.companyNameDetail}
    ${fragments.companyDetail}
    ${fragments.companyNames}
    ${fragments.personBigDetail}
    ${fragments.filmHost}
    ${fragments.personCompanies}
    ${fragments.personBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardAncestor}
    ${fragments.filmBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.filmBigAwards}
    ${fragments.awardAncestor}
    ${fragments.companyTypeTree}
    ${fragments.companyType}
  `
